var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLiveStream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1690960726197,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2305,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M895.957442 170.920521h-135.033586l49.277659-85.115957c15.99924-27.518693 6.399696-62.077051-21.118996-77.436321a55.99734 55.99734 0 0 0-77.436322 21.118996L629.730088 170.920521H394.221274L312.305166 28.2073A56.509316 56.509316 0 0 0 234.868844 7.728273c-27.518693 15.35927-36.478267 50.557599-21.118997 77.436322l49.277659 85.115957H127.99392c-70.396656 0-127.99392 57.597264-127.99392 127.99392V896.00608c0 70.396656 57.597264 127.99392 127.99392 127.99392h767.963522c70.396656 0 127.99392-57.597264 127.99392-127.99392V298.914442a127.99392 127.99392 0 0 0-127.99392-127.993921zM639.329632 630.418695a56.957295 56.957295 0 0 1-19.199088 19.839058L463.977961 748.813071c-0.63997 0-0.63997 0.63997-1.279939 0.63997-28.158662 15.99924-63.356991 5.759726-79.356231-21.758966-5.119757-9.599544-7.679635-19.839058-7.679635-30.718541V497.305018c-0.63997-32.63845 25.598784-59.517173 57.597264-60.157143 10.879483 0 21.758966 3.199848 30.718541 9.599544l157.432522 99.835258c27.518693 18.559118 35.198328 55.677355 17.919149 83.836018z",
    "p-id": 2306
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLiveStream);
export default __webpack_public_path__ + "static/media/icon-live-stream.4e02304b007393f1fa3077505a6a4ef2.svg";
export { ForwardRef as ReactComponent };